const AboutSection = () => {
  return (
    <section className="py-32 bg-white">
      <div className="container-custom section-padding">
        <div className="max-w-6xl mx-auto">
          {/* Introducción y filosofía */}
          <div className="mb-32">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="animate-slide-up">
                <h2 className="text-5xl lg:text-6xl font-light museo-font text-[#3a3a3a] mb-12">
                  Introducción y filosofía
                </h2>
                <div className="space-y-8 text-lg text-[#3a3a3a]/90 leading-relaxed">
                  <p>
                    Altta talent studio nace con una misión poco habitual en el sector: dejar atrás el modelo agotado de las agencias tradicionales y elevar el talento femenino a un espacio donde la estética no es suficiente.
                  </p>
                  <p>
                    Aquí la presencia, el estilo y la autenticidad se convierten en herramientas estratégicas para marcas que buscan más que una imagen bonita. Buscan impacto, carácter y una representación coherente con el lujo contemporáneo.
                  </p>
                  <p>
                    Defiendo una idea clara: el modelaje moderno debe ir más allá de la superficie. Creemos que la elegancia no se representa, se encarna. Por eso las mujeres de altta son perfiles con una identidad real, con criterio, con una personalidad que suma y que evita la típica uniformidad que ha lastrado al sector durante años.
                  </p>
                  <p>
                    Cada mujer adapta su esencia al universo de cada marca sin perder autenticidad. Esa es la diferencia que separa un mero recurso visual de un verdadero valor estratégico.
                  </p>
                </div>
              </div>
              <div className="animate-scale-in">
                <img 
                  src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/8ac5644062ed2075d18c47a082e8767c.webp"
                  alt="Filosofía Altta - Elegancia auténtica"
                  className="w-full h-[600px] object-cover object-top rounded-sm shadow-2xl"
                />
              </div>
            </div>
          </div>

          {/* Nuestro talento */}
          <div className="mb-32">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="animate-scale-in order-2 lg:order-1">
                <img 
                  src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/4dc1fbb39fa9574171f207391a00a4d4.webp"
                  alt="Talento femenino premium"
                  className="w-full h-[600px] object-cover object-top rounded-sm shadow-2xl"
                />
              </div>
              <div className="animate-slide-up order-1 lg:order-2">
                <h2 className="text-5xl lg:text-6xl font-light museo-font text-[#3a3a3a] mb-12">
                  Nuestro talento
                </h2>
                <div className="space-y-6 text-lg text-[#3a3a3a]/90 leading-relaxed">
                  <p>
                    Nuestra comunidad está formada por mujeres con estilo propio y capacidad innata para integrarse en narrativas visuales y experienciales de marcas premium. No son figuras estáticas ni modelos "de catálogo".
                  </p>
                  <p>
                    Son mujeres con carisma, con presencia social, con una manera de estar que eleva cualquier producción, ya sea:
                  </p>
                  <ul className="space-y-3 ml-6">
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Eventos corporativos</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Lanzamientos exclusivos</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Desfiles y showrooms</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Hoteles de 5*</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Producciones de moda</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-[#ffb7b4] mr-3">•</span>
                      <span>Experiencias boutique</span>
                    </li>
                  </ul>
                  <p>
                    Su aportación no es solo estética: es actitud, profesionalidad y un entendimiento natural del lujo actual.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
